import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconSurroundingsKidsFriendlyComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5" fill="none" />
        <path d="M15 12h.01" fill="none" />
        <path
          d="M19.38 6.813A9 9 0 0 1 20.8 10.2a2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1"
          fill="none"
        />
        <path d="M9 12h.01" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconSurroundingsKidsFriendlyComponent.displayName = 'IconSurroundingsKidsFriendly';

const IconSurroundingsKidsFriendly = memo(IconSurroundingsKidsFriendlyComponent);

export default IconSurroundingsKidsFriendly;
